import { render, staticRenderFns } from "./JFnb.vue?vue&type=template&id=8d968308&"
import script from "./JFnb.vue?vue&type=script&lang=js&"
export * from "./JFnb.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VFooter } from 'vuetify/lib/components/VFooter';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VToolbarSideIcon } from 'vuetify/lib/components/VToolbar';
installComponents(component, {VFooter,VIcon,VToolbarSideIcon})
